import React from 'react'
import {makeStyles} from "@material-ui/core"
import {BottomNavigation,BottomNavigationAction} from "@material-ui/core"
import Facebook from "@material-ui/icons/Facebook"
import Instagram from "@material-ui/icons/Instagram"
import LinkedIn from "@material-ui/icons/LinkedIn"

const useStyles=makeStyles({
    root:{
        "& .MuiBottomNavigationAction-root":{
            minWidth:0,
            maxWidth:250,
        },
        "& .MuiSvgIcon-root":{
            fill:"tan",
            "&:hover":{
                fill:"tomato",
                fontSize:"1.8rem",
            }
        }
    },
})

function Footer() {
    const classes=useStyles()
    return (
        <BottomNavigation width="auto" style={{background:"#222"}} >
           <BottomNavigationAction href="https://www.facebook.com/profile.php?id=100006896447386" className={classes.root} style={{padding:0}} icon={<Facebook></Facebook>} />

           <BottomNavigationAction href="https://www.instagram.com/ashishnagar726/?hl=en" className={classes.root} style={{padding:0}} icon={<Instagram></Instagram>} />

           <BottomNavigationAction href="https://www.linkedin.com/in/ashish-nagar-808b28146" className={classes.root} style={{padding:0}} icon={<LinkedIn></LinkedIn>} />
            
        </BottomNavigation >
    )
}

export default Footer
